import ButtonPrimary from "shared/Button/ButtonPrimary";
import React from "react";
import { Helmet } from "react-helmet";

const Page404: React.FC = () => (
  <div className="nc-Page404 flex items-center justify-center min-h-screen">
    <Helmet>
      <title>404 | Page Not Found</title>
    </Helmet>
    <div className="container relative py-16 lg:py-24">
      <header className="text-center max-w-2xl mx-auto space-y-6">
        <h1 className="text-[120px] sm:text-[160px] font-bold leading-none text-primary-6000 dark:text-primary-400">
          404
        </h1>
        <h2 className="text-2xl sm:text-3xl font-semibold text-neutral-800 dark:text-neutral-200">
          Page Not Found
        </h2>
        <span className="block text-sm sm:text-base text-neutral-600 dark:text-neutral-400 tracking-wider">
          The page you were looking for doesn't exist.
        </span>
        <div className="pt-4">
          <ButtonPrimary href="/">Return Home Page</ButtonPrimary>
        </div>
      </header>
    </div>
  </div>
);

export default Page404;
